module.exports = __webpack_public_path__ + "media/files/sample_employees_file-f97cc8d54e1d4fb780169c604581f2b1.csv";